import { render, staticRenderFns } from "./KtznAdminTextArea.vue?vue&type=template&id=534159b8&scoped=true"
import script from "./KtznAdminTextArea.vue?vue&type=script&lang=ts"
export * from "./KtznAdminTextArea.vue?vue&type=script&lang=ts"
import style0 from "./KtznAdminTextArea.vue?vue&type=style&index=0&id=534159b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534159b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextarea})
